module.exports = __webpack_public_path__ + "static/img/s3.5cd481c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/an/s3.png
// module id = dWz2
// module chunks = 1